export default __webpack_public_path__ + "static/media/2_0024.2dd472ac.webp";